import React from 'react'

import clsx from 'clsx'

import { AboutBuildingBlock } from './_blocks/AboutBuildingBlock/AboutBuildingBlock'
import { AboutHistoryBlock } from './_blocks/AboutHistoryBlock/AboutHistoryBlock'
import { AboutUsBlock } from './_blocks/AboutUsBlock/AboutUsBlock'

import s from './AboutInfoBlock.module.scss'

export type AboutInfoBlockProps = {}

export const AboutInfoBlock: React.FC<AboutInfoBlockProps> = () => {
  return (
    <div className={clsx(s.AboutInfoBlock, 'container')}>
      <AboutUsBlock />
      <AboutBuildingBlock />
      <AboutHistoryBlock />
    </div>
  )
}
